import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';

import {
  BodyDriverInfoType,
  BodyDriverInfoTypeParams,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getInsurerInformationDriverInfo/getInsurerInformationDriverInfoQuery.type';
import { getInsurerInformationDriverInfoQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getInsurerInformationDriverInfo/getInsurerInformationDriverInfoQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getInsurerInformationDriverInfoQueryOptions = (
  params: BodyDriverInfoTypeParams,
) =>
  queryOptions({
    queryKey: ['getInsurerInformationDriverInfoQueryOptions', params],
    queryFn: () => getInsurerInformationDriverInfoQueryFunction(params),
    select: (data: BodyDriverInfoType) => {
      return {
        ...data,
        personal_information: {
          ...data.personal_information,
          birthdate: data?.personal_information?.birthdate
            ? convertTimestampToShamsi(
                Number(data?.personal_information?.birthdate),
              )
            : undefined,
          gender: data?.personal_information?.gender?.const,
          is_owner_driver:
            data?.personal_information?.is_owner_driver === true
              ? 'true'
              : 'false',
          driver_iranian:
            data?.personal_information?.driver_iranian === true
              ? 'true'
              : 'false',
          at_fault_identifier: {
            label: data?.personal_information?.at_fault_identifier?.name,
            value: data?.personal_information?.at_fault_identifier?.id,
          },
          at_fault: {
            label: data?.personal_information?.at_fault?.fa_const,
            value: data?.personal_information?.at_fault?.const,
          },
        },
        certificate_information: {
          ...data.certificate_information,
          license_type: {
            label: data?.certificate_information?.license_type?.fa_name,
            value: data?.certificate_information?.license_type?.id,
          },
          license_issue_date: data?.certificate_information?.license_issue_date
            ? convertTimestampToShamsi(
                Number(data?.certificate_information?.license_issue_date),
              )
            : undefined,
          license_issue_location_country: {
            label:
              data?.certificate_information?.license_issue_location_country
                ?.name,
            value:
              data?.certificate_information?.license_issue_location_country?.id,
          },
          iran_license_issue_location_city: {
            label:
              data?.certificate_information?.iran_license_issue_location_city
                ?.name,
            value:
              data?.certificate_information?.iran_license_issue_location_city
                ?.id,
          },
          driver_license_is_extension:
            data?.certificate_information?.driver_license_is_extension,
          license_issue_location_city:
            data?.certificate_information?.license_issue_location_city,
          license_number: data?.certificate_information?.license_number,
        },
      };
    },
  });
